/**
 * A pill that opens a small explainer popover when clicked — the "GOMPA
 * Verified" and "Official Partner" badges on a monastery page.
 *
 * The popover is absolutely positioned so it floats over the content instead
 * of being dropped into the flex row the pill sits in (which stretched the
 * row and shoved its neighbours out of line). Closes on an outside click or
 * Escape.
 */
import { useEffect, useId, useRef, useState } from 'react';
import Icon from './Icon';

export default function InfoBadge({ tone = 'plain', className = '', icon, label, title, body }) {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  const panelId = useId();

  useEffect(() => {
    if (!open) return undefined;
    const onPointerDown = (event) => {
      if (!ref.current?.contains(event.target)) setOpen(false);
    };
    const onKeyDown = (event) => { if (event.key === 'Escape') setOpen(false); };
    document.addEventListener('pointerdown', onPointerDown);
    document.addEventListener('keydown', onKeyDown);
    return () => {
      document.removeEventListener('pointerdown', onPointerDown);
      document.removeEventListener('keydown', onKeyDown);
    };
  }, [open]);

  return (
    <span className={`info-badge info-badge--${tone}`} ref={ref}>
      <button
        type="button"
        className={className}
        onClick={() => setOpen((value) => !value)}
        aria-expanded={open}
        aria-controls={panelId}
      >
        {icon && <Icon name={icon} size={12} />}
        {label}
      </button>
      <div id={panelId} className="info-badge__pop" role="region" hidden={!open}>
        {title && <p className="info-badge__title">{title}</p>}
        <p className="info-badge__body">{body}</p>
      </div>
    </span>
  );
}
